import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { CouponTemplate } from 'components/Templates'

const Coupon: FC = () => {
  return (
    <Layout headline={'クーポン'} iconPath={'/icon/white/coupon.svg'} title={'クーポン'}>
      <CouponTemplate />
    </Layout>
  )
}

export default Coupon
